import axios from "axios";
import { useQuery } from "react-query";

export const useGetDashboardMetrics = () => {
  return useQuery(
    "dashboardMetrics",
    () => axios.get("/api/playground/dashboardMetrics").then((r) => r.data)
  );
};
